import React from "react";

import PostSlider from "../post/slider";

/**
 * Written by component
 * @param user user object
 * @param posts posts object
 * @returns Returns a post slider
 */
const WrittenBy = ({ user, posts }) => {

    return(
        <div>
            <h2 className="h1 author-written-by">written by { user?.firstName }</h2>
            <PostSlider overflow={ true } posts={ posts } />
        </div>
    )
}

export default WrittenBy;